<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column6">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column6">
				<form class="newsletter">
					<input type="text" :placeholder="$t('formEmail')" />
					<input type="submit" class="button" :value="button" />
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 60px 0;
	margin: 0;
	background: var(--cta-color);
	border-bottom: none;

	h2,
	div {
		color: #fff;
	}

	h2,
	h3 {
		margin: 0 0 20px;
	}

	form {
		margin-top: 30px;
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: flex-start;
		gap: 10px;

		input {
			background: var(--primary-background-color);
			padding: 15px;
			height: 52px;
			border: none;
			width: 48%;
			max-width: 300px;
			vertical-align: top;

			&::placeholder {
				color: #333;
			}

			&.button {
				line-height: 22px;
				margin: 0;
				width: auto;
				padding: 14px 30px;
				background: #000;
				color: #fff;
				max-width: 200px;

				&:hover {
					background: #111;
					color: #fff;
				}
			}
		}
	}
}
</style>
